module.exports = __webpack_public_path__ + "a2ea62aa553467d5596ef5aa98edfdd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/portrait-maurer.jpg
// module id = 119
// module chunks = 0